// @ts-nocheck

import React from "react";
import { Step, Steps, Wizard } from "react-albus";

import { Breadcrumb, Heading, Loader, Logo } from "components";

import { steps } from "./Steps";
import { useSignup } from "./store";
import * as S from "./styles";

export const Index = () => {
  const { status } = useSignup();

  return (
    <Wizard
      render={(wizard) => {
        const wizardIndex = wizard.history.index;
        const percentageProgress =
          ((wizardIndex + 1) * 100) / wizard.steps.length;

        return (
          <S.Container>
            {status === "pending" && (
              <Loader message="Aguarde, estamos validando os dados preenchidos." />
            )}

            <S.Aside.Wrap>
              <Logo color="white" />

              <S.Aside.Content>
                <S.Aside.Title>
                  Credenciamento
                  <br />
                  de Estipulante
                </S.Aside.Title>

                <S.Aside.Description>
                  Após a confirmação do credenciamento, que é feita em até 24h,
                  seu parceiro de negócios poderá atuar com os produtos Porto
                  Aluguel, Imobiliária e Essencial.
                </S.Aside.Description>

                <S.Aside.Logo />

                <S.Aside.Progress percentage={percentageProgress} />
              </S.Aside.Content>
            </S.Aside.Wrap>

            <S.Content>
              <Breadcrumb
                steps={wizard.steps.map((step, index) => {
                  const done = index < wizardIndex;

                  return {
                    icon: step.icon,
                    title: step.title,
                    done,
                    onClick: () => {
                      if (wizard.step.id === "feedback") return;
                      done && wizard.go(-(wizardIndex - index));
                    },
                  };
                })}
                current={wizardIndex}
              />

              <S.Box>
                <Heading
                  title={wizard.step.title}
                  description={wizard.step.description}
                />

                <S.Form>
                  <Steps>
                    {steps.map(({ render, ...step }) => (
                      <Step
                        key={step.id}
                        {...step}
                        render={(wizard) => render({ wizard })}
                      />
                    ))}
                  </Steps>
                </S.Form>
              </S.Box>
            </S.Content>
          </S.Container>
        );
      }}
    />
  );
};
